<template>
	<section class="bg-accented w-full min-w-screen">
		<div class="max-w-container mx-auto py-8 sm:py-12 md:pb-16 px-4 lg:px-0">
			<div class="flex flex-col items-center w-full pb-8 sm:pb-12 text-center">
				<h2 class="flex text-5xl flex-col tracking-tight text-center pb-4">
					<span class="text-primary font-semibold">
						MAVERIX’s
					</span>
					<span class="text-highlighted">
						Service Areas
					</span>
				</h2>
				<span
					class="max-w-xl"
					v-html="comingSoonText"
				/>
			</div>
			<div class="flex flex-wrap justify-center gap-x-4 gap-y-8 mx-auto">
				<ServiceAreasCityCard
					v-for="area in areas"
					:key="area.id"
					:service-area="area"
					:tracking-location="trackingLocation"
					class="w-[356px]"
				/>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import type { ServiceArea } from '@/types/components/service-areas'

defineProps({
	areas: {
		type: Object as PropType<ServiceArea[]>,
		required: true
	},
	h2: {
		type: String,
		required: true
	},
	comingSoonText: {
		type: String,
		required: true
	},
	trackingLocation: {
		type: String,
		required: true
	}
})
</script>
